export enum API_TYPES {
  MT_API_URL = 'MT_API_URL',
}

const developmentApi: Record<API_TYPES, string> = {
  // ASSISTANT_API: 'https://open-pa-api-ch-elektra.os-dev.io/api',
  MT_API_URL: 'https://mt-api.dev.mos.coke.com/v2',
  // ASSISTANT_API: 'https://open-pa-api-ch-witch.os-dev.io/api',
}

const productionApi: Record<API_TYPES, string> = {
  //   PROJECTS_API: 'WPP_TEMPLATE_ASSISTANT_API',
  MT_API_URL: 'https://mt-api.dev.mos.coke.com/v2',
}

const config = Object.keys(API_TYPES).reduce(
  (acc, type) => {
    const api =
      process.env.NODE_ENV !== 'development'
        ? process.env[`REACT_APP_${type}`] || productionApi[type as API_TYPES]
        : developmentApi[type as API_TYPES]
    return { ...acc, [type]: api }
  },
  {} as Record<API_TYPES, string>,
)

export default config
